import { storageHandler } from '../utils/storage_handler';

const authHeader = () => ({
  Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
});

const appReleasesService = {
  // Upload uses XHR so we can report progress on large binaries.
  uploadRelease(platform, file, meta, onProgress) {
    const form = new FormData();
    form.append('platform', platform);
    // version_code / version_name are optional overrides: the server reads
    // them from the binary itself (APK manifest / IPA Info.plist) when blank.
    // An empty string must be OMITTED — the API would coerce it to 0 and
    // reject it as below the version-code floor.
    if (String(meta.versionCode ?? '').trim() !== '') {
      form.append('version_code', String(meta.versionCode).trim());
    }
    if (meta.versionName && meta.versionName.trim() !== '') {
      form.append('version_name', meta.versionName.trim());
    }
    if (
      meta.minSupportedVersionCode !== '' &&
      meta.minSupportedVersionCode != null
    ) {
      form.append('min_supported_version_code', meta.minSupportedVersionCode);
    }
    form.append('is_mandatory', meta.isMandatory ? 'true' : 'false');
    if (meta.releaseNotes) form.append('release_notes', meta.releaseNotes);
    form.append('file', file);

    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', '/v1/app/releases');
      xhr.setRequestHeader('X-Client-Type', 'System');
      xhr.setRequestHeader(
        'Authorization',
        `Bearer ${storageHandler.localStorageGet('token')}`
      );

      if (onProgress) {
        xhr.upload.addEventListener('progress', (event) => {
          if (event.lengthComputable) {
            onProgress(Math.round((event.loaded / event.total) * 100));
          }
        });
      }

      xhr.onload = () => {
        try {
          const data = JSON.parse(xhr.responseText);
          if (xhr.status >= 200 && xhr.status < 300) {
            resolve(data);
          } else {
            reject(new Error(data.reason || 'Upload failed.'));
          }
        } catch {
          reject(new Error('Invalid server response.'));
        }
      };
      xhr.onerror = () => reject(new Error('Network error during upload.'));
      xhr.send(form);
    });
  },

  async getReleases(platform) {
    const res = await fetch(
      `/v1/app/releases?platform=${encodeURIComponent(platform)}`,
      { headers: authHeader() }
    );
    return res.json();
  },

  async setLatest(id) {
    const res = await fetch(`/v1/app/releases/${id}/latest`, {
      method: 'PATCH',
      headers: authHeader()
    });
    return res.json();
  },

  async setMandatory(id, isMandatory) {
    const res = await fetch(`/v1/app/releases/${id}/mandatory`, {
      method: 'PATCH',
      headers: { ...authHeader(), 'Content-Type': 'application/json' },
      body: JSON.stringify({ is_mandatory: isMandatory })
    });
    return res.json();
  },

  async deleteRelease(id) {
    const res = await fetch(`/v1/app/releases/${id}`, {
      method: 'DELETE',
      headers: authHeader()
    });
    return res.json();
  }
};

export default appReleasesService;
